export default __webpack_public_path__ + "static/media/chevron-right-disabled.87381cad.svg";